import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {Selection} from '../../../components/Selection'
import {TextInputV2} from '../../../components/TextInputV2'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterDate} from '../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../components/Table/Table'
import {SECTOR_OPTIONS} from 'src/constants'

const STATUS_OPTIONS = [
  {value: '1', label: 'Active'},
  {value: '0', label: 'Inactive'},
]

const TIME_TYPE_OPTIONS = [
  {value: 'd', label: 'Days'},
  {value: 'h', label: 'Hours'},
]

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterDate: filter} = useAppSelector(filterSelector)
  const {salesOrgOptions} = useSalesOrganization()
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterDate({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <Selection
          placeholder={t('Sector')}
          data={SECTOR_OPTIONS}
          value={filter?.sector_id ?? ''}
          onChange={(sector_id) => handleFilterChange({sector_id})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Sales Org')}
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleFilterChange({sales_org_code})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Minimal') + ' ' + t('kuantitas')}
          value={filter?.minimum_tonnase ?? ''}
          onChange={({target}) => handleFilterChange({minimum_tonnase: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Maksimal') + ' ' + t('kuantitas')}
          value={filter?.max_tonnase ?? ''}
          onChange={({target}) => handleFilterChange({max_tonnase: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Time')}
          value={filter?.time ?? ''}
          onChange={({target}) => handleFilterChange({time: target.value})}
        />
      </td>
      <td>
        <Selection
          data={TIME_TYPE_OPTIONS}
          placeholder={t('time desc')}
          value={filter?.time_type ?? ''}
          onChange={(time_type) => dispatch(setFilterDate({...filter, time_type}))}
        />
      </td>
      <td>
        <Selection
          data={STATUS_OPTIONS}
          placeholder={t('Status')}
          value={filter?.is_active ?? ''}
          onChange={(is_active) => dispatch(setFilterDate({...filter, is_active}))}
        />
      </td>
      <td className='td-order-1 text-center pm-0'>
        <div>&nbsp;</div>
      </td>
    </TRowFilter>
  )
})
